import React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

// jss
/*
const useStyle = createStyle({
  root: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    background: "#fafafa",
    alignItems: "center",
    justifyContent: "center",
    '& > .message': {
      fontSize: 20
    }
  }
})
*/

type ErrorPageProps = {
  code: string
  message: string
}
const ErrorPage: React.FC<ErrorPageProps> = ({ code, message }) => {
  const { t } = useTranslation()
  const location = useLocation()
  // const classes
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        background: "#fafafa",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ flexBasis: "auto", padding: 15 }}>
        <h1 style={{ color: "#ce0000", marginBottom: 0 }}>{code}</h1>
        <p className="message" style={{ marginBottom: 6, fontSize: 22 }}>
          {message}
        </p>
        <p style={{ fontSize: 16 }}>{t("error-page.requested-uri", [location.pathname])}</p>
        <a href="/">{t("error-page.go-home")}</a>
      </div>
    </div>
  )
}

export const Error404 = () => {
  const { t } = useTranslation()
  return <ErrorPage code="404" message={t("error-page.not-found")} />
}
export const Error401 = () => {
  const { t } = useTranslation()
  return <ErrorPage code="401" message={t("error-page.unauthorized")} />
}
